;(function (Wishlist) {

  var $wishlistButton = document.querySelectorAll('.wishlist-btn');
  var $addcartButton = document.querySelectorAll('.is-add-cart');
  var $wishlistTile = document.querySelectorAll('.wishlist-container');
  var numProductTiles = $wishlistTile.length;
  var wishlist = localStorage.getItem('user_wishlist') || [];
  if (wishlist.length > 0) {
    wishlist = JSON.parse(localStorage.getItem('user_wishlist'));
  }

  /*
   * Update button to show current state (gold for active)
   */   
  var animateWishlist = function (self) {
    self.classList.toggle('is-active');
  };

  /*
   * Add/Remove selected item to the user's wishlist array in localStorage
   * Wishlist button class 'is-active' determines whether or not to add or remove
   * If 'is-active', remove the item, otherwise add it
   */   

  var updateWishlist = function (self) {
    var productHandle = self.getAttribute('data-product-handle');
    var productId = self.getAttribute('data-product-id');
    var isRemove = self.classList.contains('is-active');
    var isaddCart = self.classList.contains('is-add-cart');
    /* Remove */
    if (isRemove) {
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      //toastr.info(mt.wishlist.removed_wishlist);
      mt.toastMsg(mt.wishlist.removed_wishlist, 'bg-info');
      self.closest('tbody').style.lineHeight = '0';
      setTimeout(function() {
        self.closest('tbody').style.display = 'none';
      }, 500);
    } else if(isaddCart) {
      //if(cart.add(productId)) {
      cart.add(productId);
      var removeIndex = wishlist.indexOf(productHandle);
      wishlist.splice(removeIndex, 1);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      self.closest('tbody').style.lineHeight = 0;
      setTimeout(function() {
        self.closest('tbody').style.display = 'none';
      }, 500);
      // }
    } else {
      /* Add */ 
      wishlist.push(productHandle);
      localStorage.setItem('user_wishlist', JSON.stringify(wishlist));
      mt.toastMsg(mt.wishlist.added_wishlist, 'bg-success');
    }
  };

  /*
   * Loop through wishlist buttons and activate any items that are already in user's wishlist
   * Activate by adding class 'is-active'
   * Run on initialization
   */ 

  var activateItemsInWishlist = function () {
    $wishlistButton.forEach(function (item) {
      var productHandle = item.getAttribute('data-product-handle');
      if (wishlist.indexOf(productHandle) > -1) {
        item.classList.add('is-active');
      }
    });
  };

  /*
   * Loop through product titles and remove any that aren't a part of the wishlist
   * Decrement numProductTiles on removal
   */

  var displayOnlyWishlistItems = function () {
    $wishlistTile.forEach(function (item) {
      var productHandle = item.getAttribute('data-product-handle');
      if (wishlist.indexOf(productHandle) === -1) {
        item.remove();
        numProductTiles--;
      }
    });
  };

  var loadWishlist = function () {
    if (window.location.href.indexOf('pages/wishlist') > -1) {
        displayOnlyWishlistItems();
        var wishlistLoader = document.querySelector('.wishlist-loader');
        wishlistLoader.style.opacity = 0;
        setTimeout(function () {
            var wishlistProduct = document.querySelectorAll('.wishlist-product');
            for (var i = 0; i < wishlistProduct.length; i++) {
                wishlistProduct[i].style.display = "table";
            }
            if (numProductTiles == 0) {
                var wishlistEmpty = document.querySelector('.wishlist-empty');
                var wishlistHead = document.querySelector('.wishlist-head');
                wishlistEmpty.style.display = "block";
                wishlistHead.style.display = "none";
            } else {
                var wishlistEmpty = document.querySelector('.wishlist-empty');
                wishlistEmpty.style.display = "none";
            }
        }, 500);
    }
};

var bindUIActions = function () {
  $wishlistButton.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  });
  $addcartButton.forEach(function (item) {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      updateWishlist(this);
      animateWishlist(this);
    });
  });
};

Wishlist.init = function () {
  bindUIActions();
  activateItemsInWishlist();
  loadWishlist();
};
}(window.Wishlist = window.Wishlist || {}));